// Third-party
import React from 'react';

// Components
import { TextCell } from '../../../../../views/components/cells';

// Types
import ProposalTableCellData from '@/types/proposal-table-cell-data';
import Locale from '@/types/locale';

interface CellProps {
  proposalTableCellData: ProposalTableCellData;
  locale: Locale;
}

export const Cell = ({ proposalTableCellData, locale }: CellProps) =>
  React.createElement(proposalTableCellData.cellType || TextCell, {
    value: proposalTableCellData.value,
    prefix: proposalTableCellData.prefix,
    color: proposalTableCellData.color,
    type: proposalTableCellData.itemType,
    format: proposalTableCellData.cellFormat,
    withSuffixes: proposalTableCellData.withSuffixes,
    tooltipMessage: proposalTableCellData.tooltipMessage,
    locale,
    decimalPlace: proposalTableCellData.decimalPlace,
    decimals: proposalTableCellData.decimalPlace, // CurrencyCell uses a "decimals" prop instead of "decimalPlace"
    clamp: proposalTableCellData.clamp,
    hasDisclaimer: proposalTableCellData.hasDisclaimer,
    disclaimerNumber: proposalTableCellData.disclaimerNumber,
    disclaimerKey: proposalTableCellData.disclaimerKey,
    sectionKey: proposalTableCellData.sectionKey,
    asteriskDisclaimerKey: proposalTableCellData.asteriskDisclaimerKey,
    currency: proposalTableCellData.currency,
    flags: proposalTableCellData.flags,
  });
